import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size, width } from '@twistopayments/design-system/styles'

export const container = css`
  margin: 0 auto;
  padding: 0 ${size[20]};
  max-width: ${width.container.large};
`

export const feature = css`
  padding: 0 ${size[20]};
  margin: auto;
  margin-bottom: ${size[96]};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;

  ${breakpoint.up('smMd')} {
    padding: 0 ${size[20]};
    max-width: ${width.container.large};
    flex-direction: row;
  }
`

export const reversed = css`
  ${breakpoint.up('smMd')} {
    flex-direction: row-reverse;
  }
`

export const text = css`
  ${breakpoint.up('smMd')} {
    max-width: ${width.modal.compact};
  }
`

export const cta = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${size[32]};
  text-align: center;
  margin-top: ${size[32]};

  ${breakpoint.up('smMd')} {
    justify-content: flex-start;
    margin-top: ${size[60]};
  }
`

export const media = (theme: Theme) => css`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 100%;
  margin-bottom: ${size[32]};

  img,
  video {
    width: 100%;
    height: auto;
    border-radius: ${theme.borderRadius.sm} ${theme.borderRadius.xl};
  }

  video {
    clip-path: inset(0.01px 0.01px);
  }

  ${breakpoint.up('smMd')} {
    width: 50%;
    max-width: 550px;
    margin-bottom: 0;

    img,
    video {
      border-radius: ${theme.borderRadius.md} ${theme.borderRadius.xxl};
    }
  }
`
